/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Book_100_Private_SecureInputs */

const en_book_100_private_secure = /** @type {(inputs: Book_100_Private_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% Private & Secure.`)
};

const es_book_100_private_secure = /** @type {(inputs: Book_100_Private_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% Privado y Seguro.`)
};

const fr_book_100_private_secure = /** @type {(inputs: Book_100_Private_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% Privé et Sécurisé.`)
};

const de_book_100_private_secure = /** @type {(inputs: Book_100_Private_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% Privat & Sicher.`)
};

const ja_book_100_private_secure = /** @type {(inputs: Book_100_Private_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100%プライベート＆安全。`)
};

const zh_book_100_private_secure = /** @type {(inputs: Book_100_Private_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% 私密与安全。`)
};

const ar_book_100_private_secure = /** @type {(inputs: Book_100_Private_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خاص وآمن 100%.`)
};

const id_book_100_private_secure = /** @type {(inputs: Book_100_Private_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% Privat & Aman.`)
};

const it_book_100_private_secure = /** @type {(inputs: Book_100_Private_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% Privato e Sicuro.`)
};

const ru_book_100_private_secure = /** @type {(inputs: Book_100_Private_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% конфиденциально и безопасно.`)
};

const pt_book_100_private_secure = /** @type {(inputs: Book_100_Private_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% Privado e Seguro.`)
};

const ko_book_100_private_secure = /** @type {(inputs: Book_100_Private_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% 비공개 및 안전.`)
};

/**
* | output |
* | --- |
* | "100% Private & Secure." |
*
* @param {Book_100_Private_SecureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const book_100_private_secure = /** @type {((inputs?: Book_100_Private_SecureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Book_100_Private_SecureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_book_100_private_secure(inputs)
	if (locale === "es") return es_book_100_private_secure(inputs)
	if (locale === "fr") return fr_book_100_private_secure(inputs)
	if (locale === "de") return de_book_100_private_secure(inputs)
	if (locale === "ja") return ja_book_100_private_secure(inputs)
	if (locale === "zh") return zh_book_100_private_secure(inputs)
	if (locale === "ar") return ar_book_100_private_secure(inputs)
	if (locale === "id") return id_book_100_private_secure(inputs)
	if (locale === "it") return it_book_100_private_secure(inputs)
	if (locale === "ru") return ru_book_100_private_secure(inputs)
	if (locale === "pt") return pt_book_100_private_secure(inputs)
	return ko_book_100_private_secure(inputs)
});